<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Novo suporte</span>
      </h1>
      <div>
        <PrimaryButton @click="submit()" class="px-5" icon="fa-solid fa-paper-plane">Enviar</PrimaryButton>
      </div>
    </div>
  </div>

  <div class="align p-4 space_title">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <InputText label="Assunto" v-model="support.title" :error="formErrors.title" />
              </div>

              <div class="col-12 mb-3">
                <TextArea label="Mensagem" v-model="support.content" :error="formErrors.content" />
              </div>

              <div class="col-12">
                <FileUpload v-model="support.attachment" :error="formErrors.attachment" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import TextArea from '@/components/TextArea.vue'
import FileUpload from '@/components/FileUpload.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import { useSupportStore } from '@/stores/SupportStore'
import { inject, onMounted, ref } from 'vue';
import { useToast, TYPE } from "vue-toastification";
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import {errorFormat} from "@/utils/errorFormat";
const toast = useToast();

const loader = inject('$loader');

const formErrors = ref({});

const supportStore = useSupportStore();
const { support } = storeToRefs(supportStore);

const router = useRouter();

onMounted(async () => {
  supportStore.support = {};
});

const submit = async () => {
  let params = {
    title: supportStore.support.title,
    content: supportStore.support.content,
    attachment: supportStore.support.attachment,
  };

  loader.show();
  formErrors.value = {};

  const formResult = await supportStore.addSupport(params);
  if (formResult.success) {
    toast('Suporte enviado', { type: TYPE.SUCCESS, timeout: 6000 });
    router.push({ name: 'support', params: { id: supportStore.support.id } });
  }
  else {
    formErrors.value = errorFormat(formResult.errors);
  }

  loader.hide();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}
</style>